/* src/app/ship/components/delivery-defense/delivery-defense-score-information-dialog/delivery-defense-score-information-dialog.component.scss */
.dialog-header {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.dialog-header .mat-mdc-dialog-title {
  font-size: 1.2rem;
  font-weight: 700;
  padding: 1rem 2rem 0 2rem;
  margin: 0 auto;
}
.dialog-header .close-icon {
  position: absolute;
  top: 0.75em;
  right: 0.5em;
}
.dialog-content {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  padding: 2rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 0 2rem 2rem;
  }
}
.gauge {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .gauge {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 1rem 0;
  }
}
.gauge .gauge-labels,
.gauge .gauge-values {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-between;
  color: #121212;
  font-size: 0.7465rem;
  font-weight: 500;
  line-height: 8;
  width: 2rem;
  white-space: nowrap;
}
@media screen and (min-width: 48rem) {
  .gauge .gauge-labels,
  .gauge .gauge-values {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    justify-content: space-between;
    line-height: 1.11975rem;
    width: unset;
    white-space: unset;
  }
}
.gauge .gauge-labels .gauge-label,
.gauge .gauge-labels .gauge-value,
.gauge .gauge-values .gauge-label,
.gauge .gauge-values .gauge-value {
  transform: rotate(-90deg);
}
@media screen and (min-width: 48rem) {
  .gauge .gauge-labels .gauge-label,
  .gauge .gauge-labels .gauge-value,
  .gauge .gauge-values .gauge-label,
  .gauge .gauge-values .gauge-value {
    transform: none;
  }
}
.gauge .gauge-values {
  line-height: 2.5;
}
.gauge .gauge-wrapper {
  display: block;
  width: 1.16644rem;
  height: 100%;
  border-radius: 0.46656rem;
  background:
    linear-gradient(
      0deg,
      #F66E6E 0%,
      #F6AC68 25%,
      #F1D367 49.48%,
      #E1F46D 72.4%,
      #97F26C 100%);
  box-shadow: 0 2.98601px 8.95802px -2.23951px rgba(0, 0, 0, 0.05), 0 1.493px 3.73251px 0px rgba(0, 0, 0, 0.14);
  position: relative;
}
@media screen and (min-width: 48rem) {
  .gauge .gauge-wrapper {
    width: 100%;
    height: 1.16644rem;
    background:
      linear-gradient(
        90deg,
        #F66E6E 0%,
        #F6AC68 25%,
        #F1D367 49.48%,
        #E1F46D 72.4%,
        #97F26C 100%);
  }
}
.scores {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column-reverse;
  gap: 1px;
  border-bottom: 0.658px solid #D9D9D9;
  flex: 1;
}
@media screen and (min-width: 48rem) {
  .scores {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }
}
.scores .score {
  flex: 1;
}
@media screen and (min-width: 48rem) {
  .scores .score:last-of-type {
    flex: 0.5454545455;
  }
}
.scores .score .score-range {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #4A4A4C;
  color: white;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.25;
  height: 2.30263rem;
}
.scores .score ::ng-deep .score-message {
  font-size: 0.65788rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.15131rem;
  text-align: center;
  padding: 1rem 0.5rem;
}
.scores .score ::ng-deep .score-message .multiplier,
.scores .score ::ng-deep .score-message .range {
  display: block;
}
.scores .score ::ng-deep .score-message .multiplier {
  font-size: 0.82238rem;
  font-weight: 700;
}
:host(.delivery-defense-score-information-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  position: relative;
}
@media screen and (min-width: 48rem) {
  :host(.delivery-defense-score-information-dialog) {
    height: auto;
  }
}
/*# sourceMappingURL=delivery-defense-score-information-dialog.component.css.map */
